module.exports = __webpack_public_path__ + "media/images/admin/icons/chrome-9afafdbadd3f58382f91e18b9159feb2.svg";